<nz-spin [nzSpinning]="isLoading" [nzIndicator]="purpleModalLoaderTemplate">
  <app-purple-form *ngIf="purpleFormFieldGroups!= undefined" [disbledForm]="disableForm" [(formGroup)]="validateForm"
    [purpleFormFieldGroups]="purpleFormFieldGroups" [refreshFormFields]="refreshFormFields">
  </app-purple-form>
</nz-spin>
<ng-template #purpleModalLoaderTemplate>
  <div class="purple-modal-custom-spinner">
    <span nz-icon nzType="loading"></span>
  </div>
</ng-template>
<div class="purple-button-container ps-w-100 ps-d-flex">
  <button (click)="editNotificationException()" nz-button class="purple-modal-button" [disabled]="isLoading"
    [nzLoading]="isLoading">
    <span *ngIf="!isNew">
      {{ 'edit_system_event_notification_exception_save_button' | translation: 'Salva Modifiche': []}}
    </span>
    <span *ngIf="isNew">
      {{ 'edit_system_event_notification_exception_add_new_exception' | translation: 'Aggiungi Eccezione': []}}
    </span>
  </button>
</div>